module.exports = __webpack_public_path__ + "static/media/logo_banner.d25a7e09.jpg";